const middleware = {}

middleware['auth'] = require('../middleware/auth.ts')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['loadResources'] = require('../middleware/loadResources.ts')
middleware['loadResources'] = middleware['loadResources'].default || middleware['loadResources']

middleware['profiledRouting'] = require('../middleware/profiledRouting.ts')
middleware['profiledRouting'] = middleware['profiledRouting'].default || middleware['profiledRouting']

middleware['redirectToDashboard'] = require('../middleware/redirectToDashboard.ts')
middleware['redirectToDashboard'] = middleware['redirectToDashboard'].default || middleware['redirectToDashboard']

export default middleware
